// Process colors for display
export const processColors = {
  1: "#1976d2",
  2: "#ff9800",
  3: "#2e7d32",
  4: "#d32f2f",
  5: "#7b1fa2",
  6: "#0288d1",
  7: "#ef6c00",
  8: "#00796b",
  9: "#c2185b",
  10: "#303f9f",
  11: "#f57c00",
  12: "#388e3c",
  13: "#1565c0",
  14: "#5e35b1",
  15: "#d81b60",
  16: "#00acc1",
  17: "#43a047",
};
